
export const GET_EMPLOYEEINFO_STARTED = "GET_EMPLOYEEINFO_STARTED";
export const GET_EMPLOYEEINFO_SUCESS = "GET_EMPLOYEEINFO_SUCESS";
export const GET_EMPLOYEEINFO_FAILED = "GET_EMPLOYEEINFO_FAILED";

export interface IManageuser {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    MODEMInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}
export const getAllEmployeeInfoDetails = (companyId) => {
     
     return {
         type: GET_EMPLOYEEINFO_STARTED ,
         payload: 'Value',
         input:companyId
     };
 };
 